export const REGISTER_TRIAL_USER = 'register_trial_user';
export const REGISTER_TRIAL_USER_SUCCESSFUL = 'register_trial_user_successfull';
export const REGISTER_TRIAL_USER_FAILED = 'register_trial_user_failed';
export const SET_MESSAGE = 'set_message';
export const CLEAR_MESSAGE = 'clear_message';

export const GET_NEW_TRIAL_USER = 'get_new_trial_user';
export const GET_TRIAL_USER_FAILED = 'get_new_trial_user_failed';
export const GET_TRIAL_USER_SUCCESSFUL = 'get_new_trial_user_successful';

export const UPDATE_TRIAL_USER = 'update_new_trial_user';
export const UPDATE_TRIAL_USER_SUCCESSFUL = 'update_new_trial_user_successful';

export const SEND_REGISTER_TRIAL_USER_EMAIL = 'send_register_trial_user_email';
export const SEND_REGISTER_TRIAL_USER_EMAIL_SUCCESSFUL = 'send_register_trial_user_email_successful';
export const SEND_REGISTER_TRIAL_USER_EMAIL_FAILED = 'send_register_trial_user_email_failed';

export const DELETE_TRIAL_USER = 'delete_new_trial_user';
export const DELETE_TRIAL_USER_FAILED = 'delete_new_trial_user_failed';
export const DELETE_TRIAL_USER_SUCCESSFUL = 'delete_new_trial_user_successful';